import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { OebsConfigExtRouter } from './oebs-config.router';
import { reducers } from './state/oebs-config.selectors';

@NgModule({
  imports: [
    OebsConfigExtRouter,
    StoreModule.forFeature('oebsConfig', reducers),
  ],
  declarations: []
})
export class OebsConfigExtScreenModule { }